var _g, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 2,
    width: 40,
    height: 40,
    rx: 12,
    fill: "#00A0F3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2124 17.7624C28.2124 20.4062 26.049 22.5248 23.3494 22.5248C20.6507 22.5248 18.4863 20.4062 18.4863 17.7624C18.4863 15.1187 20.6507 13 23.3494 13C26.049 13 28.2124 15.1187 28.2124 17.7624ZM16 27.9175C16 25.4701 19.3855 24.8578 23.3493 24.8578C27.3347 24.8578 30.6987 25.4912 30.6987 27.9405C30.6987 30.3878 27.3131 31.0001 23.3493 31.0001C19.364 31.0001 16 30.3667 16 27.9175ZM30.1734 17.8481C30.1734 19.1944 29.7605 20.4506 29.0364 21.4941C28.9611 21.6015 29.0276 21.7462 29.1587 21.7691C29.3407 21.7989 29.5276 21.8171 29.7184 21.8209C31.6167 21.8698 33.3202 20.6729 33.7908 18.8705C34.4885 16.1961 32.4415 13.7947 29.8339 13.7947C29.5511 13.7947 29.2801 13.8235 29.0159 13.8762C28.9797 13.8839 28.9405 13.9011 28.921 13.9318C28.8955 13.9711 28.9141 14.0218 28.9395 14.0554C29.7233 15.1315 30.1734 16.4414 30.1734 17.8481ZM33.3173 23.7029C34.5932 23.9472 35.4318 24.4446 35.7791 25.1699C36.0736 25.764 36.0736 26.454 35.7791 27.0481C35.2478 28.1711 33.5335 28.5324 32.8672 28.6253C32.7292 28.6445 32.6186 28.5295 32.6333 28.3934C32.9738 25.2811 30.2664 23.8054 29.5658 23.4662C29.5364 23.4499 29.5296 23.4269 29.5325 23.4116C29.5345 23.402 29.5472 23.3867 29.5697 23.3838C31.0854 23.355 32.7155 23.5592 33.3173 23.7029Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHUsers);
export default __webpack_public_path__ + "static/media/HUsers.67367fe3.svg";
export { ForwardRef as ReactComponent };